/**
 * useContent like hook effect
 *
 * @export
 */
export function useContent(content) {
  const { id: contentId, title, release, duration = 0, flights, genres, participants, description, ratings, contentType, entitlementTypes, ratingDescriptors, sport, live } = content ?? {};
  const [{ flights: arrayFlightsStartEnd }] = flights ?? [{}];
  const [{ start, end: endFlight }] = arrayFlightsStartEnd ?? [{}];

  return {
    contentId,
    title,
    description,
    ratings,
    release,
    duration,
    endFlight,
    start,
    sport,
    arrayFlightsStartEnd
  } 
}
